<mat-icon>{{this.icon}}</mat-icon>